// extracted by mini-css-extract-plugin
module.exports = {"white100":"#fff","primary":"#400099","primaryD10":"#2b0066","errorMessages":"medkit__ErrorMessages__errorMessages","errorMessage":"medkit__ErrorMessages__errorMessage"};